import ChatService from 'domain/services/chat/ChatServices';
import { useAppDispatch } from 'redux/hooks';
import usePagination from 'hooks/usePagination';
import { addAllMessages, popNewMessages } from 'redux/chat/actions';

export default function useMessages() {
  const dispatch = useAppDispatch();
  const { setCurrentPage, setTotalCount, calculateOffset, currentPage, setLimit, hasNext } =
    usePagination();

  function orderByAsc(messages: any) {
    return messages.sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at));
  }

  async function getAllMessages(id: string, offset = 0) {
    const lm = 50;
    setLimit(lm);
    const props = {
      offset,
      chat_id: id,
      limit: lm,
    };

    const data = await ChatService.getPreviousMessages(props);

    if (!data?.chat_messages_aggregate) return;
    setTotalCount(data.chat_messages_aggregate.aggregate.count);
    if (data.chat_messages.length === 0) {
      return;
    }
    return data.chat_messages;
  }

  function addNewMessages(messages) {
    if (!messages) return;
    dispatch(addAllMessages(orderByAsc([...messages])));
  }

  function popMessages(messages) {
    if (!messages) return;
    dispatch(popNewMessages(orderByAsc([...messages])));
  }

  async function queryMore(chatId: string): Promise<void> {
    const newPage = currentPage + 1;
    setCurrentPage(newPage);
    const messages = await getAllMessages(chatId, calculateOffset(newPage));
    popMessages(messages);
  }

  function queryLess(chatId: string) {
    setCurrentPage(1);
    getAllMessages(chatId);
  }

  return {
    getAllMessages,
    queryMore,
    queryLess,
    hasNext,
    addNewMessages,
    setCurrentPage,
  };
}
